import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { OdsConfigPaymentsPage } from '../../ods/ods-config/ods-config-payments/ods-config-payments';
import { ConfigurationPaymentsGetnetPage } from './configuration-payments-getnet/configuration-payments-getnet';
import { ConfigurationPaymentsComerciaGlobalPayPage } from './configuration-payments-comerciaglobalpay/configuration-payments-comerciaglobalpay';


/**
 * Generated class for the ConfigurationPaymentMethodsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-payment-methods',
    templateUrl: 'configuration-payment-methods.html',
})
export class ConfigurationPaymentMethodsPage {

    public form: FormGroup;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public fb: FormBuilder,
        public translate: TranslateService) {
        //init if undefined - init always false
        if (this.globals.restaurant.payment_method_bank_transfer == undefined) {
            this.globals.restaurant.payment_method_bank_transfer = false;
        }
        if (this.globals.restaurant.payment_method_american_express == undefined) {
            this.globals.restaurant.payment_method_american_express = false;
        }
        if (this.globals.restaurant.payment_method_bizum == undefined) {
            this.globals.restaurant.payment_method_bizum = false;
        }
        if (this.globals.restaurant.payment_method_online == undefined) {
            this.globals.restaurant.payment_method_online = false;
        }
        if (this.globals.restaurant.payment_method_bank_draft == undefined) {
            this.globals.restaurant.payment_method_bank_draft = false;
        }
        if (this.globals.restaurant.payment_method_cryptocurrencies == undefined) {
            this.globals.restaurant.payment_method_cryptocurrencies = false;
        }
        if (this.globals.restaurant.payment_method_ticket_restaurant == undefined) {
            this.globals.restaurant.payment_method_ticket_restaurant = false;
        }
        if (this.globals.restaurant.payment_not_specified == undefined) {
            this.globals.restaurant.payment_not_specified = false;
        }
        if (this.globals.restaurant.payment_method_redsys_top == undefined) {
            this.globals.restaurant.payment_method_redsys_top = false;
        }
        if (this.globals.restaurant.payment_method_redsys_offline == undefined) {
            this.globals.restaurant.payment_method_redsys_offline = false;
        }
        if (this.globals.restaurant.payment_method_comerciaglobalpay_top == undefined) {
            this.globals.restaurant.payment_method_comerciaglobalpay_top = false;
        }
        //init form
        this.form = fb.group({
            payment_method_bank_transfer: [this.globals.restaurant.payment_method_bank_transfer],
            payment_method_american_express: [this.globals.restaurant.payment_method_american_express],
            payment_method_bizum: [this.globals.restaurant.payment_method_bizum],
            payment_method_online: [this.globals.restaurant.payment_method_online],
            payment_method_bank_draft: [this.globals.restaurant.payment_method_bank_draft],
            payment_method_cryptocurrencies: [this.globals.restaurant.payment_method_cryptocurrencies],
            payment_method_ticket_restaurant: [this.globals.restaurant.payment_method_ticket_restaurant],
            payment_not_specified: [this.globals.restaurant.payment_not_specified],
            payment_method_redsys_offline: [this.globals.restaurant.payment_method_redsys_offline],
            payment_method_redsys_top: [this.globals.restaurant.payment_method_redsys_top],
            payment_method_comerciaglobalpay_top: [this.globals.restaurant.payment_method_comerciaglobalpay_top],
        });
    }

    submit() {
        //check tap on phone santander
        if (this.form.value.payment_method_redsys_top === true && (this.globals.restaurant.payment_method_redsys_top_user_id == undefined || this.globals.restaurant.payment_method_redsys_top_user_token == '' || this.globals.restaurant.payment_method_redsys_top_client_id == '' || this.globals.restaurant.payment_method_redsys_top_merchant_id == undefined)) {
            this.globals.restaurant.payment_method_redsys_top = false;
            this.form.patchValue({
                payment_method_redsys_top: this.globals.restaurant.payment_method_redsys_top
            });
            //toast
            this.globals.launchToast(this.translate.instant('general-faltan-datos-getnet-top'), 3500, 'top');
        }
        //check tap on phone caixabank
        if (this.form.value.payment_method_comerciaglobalpay_top === true && (this.globals.restaurant.payment_method_comerciaglobalpay_top_merchant_id == undefined || this.globals.restaurant.payment_method_comerciaglobalpay_top_terminal_id == '' || this.globals.restaurant.payment_method_comerciaglobalpay_top_activation_code == '')) {
            this.globals.restaurant.payment_method_comerciaglobalpay_top = false;
            this.form.patchValue({
                payment_method_comerciaglobalpay_top: this.globals.restaurant.payment_method_comerciaglobalpay_top
            });
            //toast
            this.globals.launchToast(this.translate.instant('general-faltan-datos-comerciaglobalpay-top'), 3500, 'top');
        }
        //save
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'payment_method_bank_transfer': this.form.value.payment_method_bank_transfer,
            'payment_method_american_express': this.form.value.payment_method_american_express,
            'payment_method_bizum': this.form.value.payment_method_bizum,
            'payment_method_online': this.form.value.payment_method_online,
            'payment_method_bank_draft': this.form.value.payment_method_bank_draft,
            'payment_method_cryptocurrencies': this.form.value.payment_method_cryptocurrencies,
            'payment_method_ticket_restaurant': this.form.value.payment_method_ticket_restaurant,
            'payment_not_specified': this.form.value.payment_not_specified,
            'payment_method_redsys_offline': this.form.value.payment_method_redsys_offline,
            'payment_method_redsys_top': this.form.value.payment_method_redsys_top,
            'payment_method_comerciaglobalpay_top': this.form.value.payment_method_comerciaglobalpay_top
        }).then(() => {
            this.globals.restaurant.payment_method_bank_transfer = this.form.value.payment_method_bank_transfer;
            this.globals.restaurant.payment_method_american_express = this.form.value.payment_method_american_express;
            this.globals.restaurant.payment_method_bizum = this.form.value.payment_method_bizum;
            this.globals.restaurant.payment_method_online = this.form.value.payment_method_online;
            this.globals.restaurant.payment_method_bank_draft = this.form.value.payment_method_bank_draft;
            this.globals.restaurant.payment_method_cryptocurrencies = this.form.value.payment_method_cryptocurrencies;
            this.globals.restaurant.payment_method_ticket_restaurant = this.form.value.payment_method_ticket_restaurant;
            this.globals.restaurant.payment_not_specified = this.form.value.payment_not_specified;
            this.globals.restaurant.payment_method_redsys_offline = this.form.value.payment_method_redsys_offline;
            this.globals.restaurant.payment_method_redsys_top = this.form.value.payment_method_redsys_top;
            this.globals.restaurant.payment_method_comerciaglobalpay_top = this.form.value.payment_method_comerciaglobalpay_top;
            //
            this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 1500, 'top');
        });
    }

    configOnlinePayments() {
        this.navCtrl.push(OdsConfigPaymentsPage);
    }

    configGetnetPayments() {
        this.navCtrl.push(ConfigurationPaymentsGetnetPage);
    }
    
    configComerciaGlobalPayPayments() {
        this.navCtrl.push(ConfigurationPaymentsComerciaGlobalPayPage);
    }

    checkIfQRActive() {
        if (this.globals.restaurant.payment_method_stripe || this.globals.restaurant.payment_method_paypal || this.globals.restaurant.payment_method_redsys || this.globals.restaurant.payment_method_redsys_bizum) {
            return true;
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-methods.ts